/**
 * Shared testimonial Zod schema used by renderers that show a
 * social-proof testimonial card (`trust_screen`, `loading_screen`,
 * and any future renderer with the same UX).
 *
 * Lifted out of those renderers to prevent silent divergence — same
 * pattern as `choiceOptionSchema.ts` for `single_choice` /
 * `multi_choice`. Adding or renaming a field happens in one place.
 */
import { z } from "zod";

import { urlOrTemplate } from "@survey-kit/urlOrTemplate";

export const testimonialSchema = z.object({
  id: z.string().min(1),
  body: z.string().min(1),
  authorName: z.string().min(1),
  authorAvatarUrl: urlOrTemplate.optional(),
  rating: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)]),
});

export type TestimonialData = z.infer<typeof testimonialSchema>;
